import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SpreedSheetGridService {
    private refreshGridSource = new Subject<any>();

    refreshGridSource$ = this.refreshGridSource.asObservable();

    refreshGridRows(rowData: any) {
        this.refreshGridSource.next(rowData);
      }
}